(() => {
  'use strict';
  function init(root = document) {
    root.querySelectorAll('[data-menu-toggle]').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      const menu = document.getElementById(button.getAttribute('aria-controls'));
      if (!menu) return;
      button.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(open)); menu.hidden = !open;
      });
      menu.addEventListener('click', e => { if (e.target.closest('a')) {menu.hidden = true; button.setAttribute('aria-expanded', 'false');} });
      document.addEventListener('keydown', e => { if (e.key === 'Escape' && !menu.hidden) {menu.hidden = true; button.setAttribute('aria-expanded','false');button.focus();} });
    });
    root.querySelectorAll('[data-quantity]').forEach(control => {
      if (control.dataset.bound) return;
      control.dataset.bound = 'true';
      const input = control.querySelector('input');
      control.querySelectorAll('button').forEach(b => b.addEventListener('click', () => {
        const step = Number(input.step) || 1, min = Number(input.min) || 0, max = input.max ? Number(input.max) : Infinity;
        input.value = Math.min(max, Math.max(min, (Number(input.value) || min) + Number(b.dataset.delta) * step));
        input.dispatchEvent(new Event('change', {bubbles:true}));
      }));
    });
    root.querySelectorAll('[data-product]').forEach(product => {
      if (product.dataset.bound) return;
      product.dataset.bound = 'true';
      const form = product.querySelector('.product-form');
      const select = form?.querySelector('[name="id"]');
      function updateVariant() {
        if (!select) return;
        const opt = select.selectedOptions[0];
        if (!opt) return;
        const price = product.querySelector('[data-price]'), compare = product.querySelector('[data-compare]'), submit = form.querySelector('[name="add"]');
        if (price) price.textContent = opt.dataset.price;
        if (compare) {compare.textContent = opt.dataset.compare || ''; compare.hidden = !opt.dataset.compare;}
        if (submit) {submit.disabled = opt.dataset.available !== 'true'; submit.querySelector('[data-add-label]').textContent = submit.disabled ? 'Ausverkauft' : 'In den Warenkorb';}
        const quantity = form.querySelector('[name="quantity"]');
        if (quantity) {quantity.min = opt.dataset.min || '1';quantity.step = opt.dataset.step || '1';quantity.max = opt.dataset.max || '';quantity.value = quantity.min;}
        if (opt.dataset.image) {const image = product.querySelector('[data-main-image]');if(image){image.src=opt.dataset.image;image.removeAttribute('srcset');}}
      }
      select?.addEventListener('change', () => {updateVariant();const url=new URL(location.href);url.searchParams.set('variant',select.value);history.replaceState({},'',url);});
      if (select) {const id = new URL(location.href).searchParams.get('variant');if(id && Array.from(select.options).some(o=>o.value===id)) select.value=id; updateVariant();}
      product.querySelectorAll('[data-media-src]').forEach(button => button.addEventListener('click', () => {
        const img=product.querySelector('[data-main-image]'); if(!img) return;
        img.src=button.dataset.mediaSrc;img.removeAttribute('srcset');img.alt=button.dataset.mediaAlt || '';
        product.querySelectorAll('[data-media-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      }));
    });
    root.querySelectorAll('input[type="file"][data-photo]').forEach(input => {
      if(input.dataset.bound) return; input.dataset.bound='true';
      input.addEventListener('change',()=>{
        const file=input.files[0];input.setCustomValidity('');
        if(file && file.size>20*1024*1024) input.setCustomValidity('Bitte wähle ein Foto mit maximal 20 MB.');
        if(file && !/\.(jpe?g|png|webp|heic|heif)$/i.test(file.name)) input.setCustomValidity('Bitte verwende JPG, PNG, WebP oder HEIC.');
        const label=input.closest('label')?.querySelector('.file-name');if(label)label.textContent=file?.name || 'Foto auswählen';
        if(input.validationMessage) input.reportValidity();
      });
    });
    root.querySelectorAll('[data-sort]').forEach(select => {if(select.dataset.bound)return;select.dataset.bound='true';select.addEventListener('change',()=>{if(document.body.dataset.preview)return;const u=new URL(location.href);u.searchParams.set('sort_by',select.value);u.searchParams.delete('page');location.assign(u);});});
  }
  init(); document.addEventListener('shopify:section:load', e => init(e.target));
})();
